import { createAsyncThunk } from '@reduxjs/toolkit';
import { namesService } from '../../../api';

export const fetchSearchNames = createAsyncThunk('names/search', (searchValue: string) => namesService.search(searchValue));
